import styled, { keyframes } from 'styled-components/macro'

import { theme } from 'styles/theme'
import { motion } from 'framer-motion'

export const View = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--background);
  z-index: 999;
`

const loading = keyframes`
  from { transform: scaleX(.5) translateX(-150%); }
  to   { transform: scaleX(.5) translateX(150%); }
`

export const Spinner = styled(motion.div)`
  position: relative;
  height: 0.5rem;
  width: 20rem;
  max-width: calc(100% - 4rem);
  margin-top: 3rem;
  overflow: hidden;
  background-color: #eee;

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    animation: 1s ${loading} ease-in-out infinite;
    background-color: ${theme.colors.accent.rfe};
  }

  html[dir='rtl'] &::before {
    animation-direction: reverse;
  }
`

export const Logo = styled.img`
  width: 10rem;
`
